import {
  getSession as fetchSession,
  getUser as fetchUser,
  getUserAvatar as fetchUserAvatar,
} from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { Session, sessionFromDto, User, UserAvatarDto, UserDto, userFromDto } from '@nx-frontend/shared/types';
import { logger } from '@nx-frontend/shared/utils';

export async function getUser(sessionId: string): Promise<User | null> {
  let session: Session | null = null;
  let user: UserDto | null = null;
  let avatar: UserAvatarDto | null = null;

  try {
    session = sessionFromDto(await fetchSession({ host: generalEnv.userServiceUrl, sessionId }));
  } catch (err) {
    logger.warn(`getSession error: %j`, err);
  }

  if (session) {
    try {
      const payload = {
        host: generalEnv.userServiceUrl,
        userId: session.userId,
      };

      const [userResponse, userAvatarResponse] = await Promise.all(
        [fetchUser(payload), fetchUserAvatar(payload)].map((promise) =>
          promise.catch((error) => {
            logger.warn('Fail to fetch user %d %j', session?.userId, error);
            return null;
          })
        )
      );

      user = userResponse as UserDto;
      avatar = userAvatarResponse as UserAvatarDto;
    } catch (err) {
      logger.warn(`getUser %d error: %j`, session?.userId, err);
    }
  }

  if (user) {
    return userFromDto(user, avatar?.storedFileUUID);
  }

  return null;
}
